import { BetBuilderPickResponse } from "@api-types/bet-booster/BetBuilderPickResponse";
import { GenericResponse } from "@api-types/common";
import { getApplicationHeaders, httpClient } from "@utils";

export class BetBuilderApiService {
	static get baseUrl() {
		return `${WEBPACK_BET_BOOSTER_API_ADDRESS}/bet-builder`;
	}
	static getRequestHeaders() {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static getEventBetBuilderPicksAvailability(
		eventId: string
	): Promise<GenericResponse<BetBuilderPickResponse[]>> {
		return httpClient.get(
			`${this.baseUrl}/presets/event/${eventId}`,
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	static getBetBuilderPicksAvailability(): Promise<
		GenericResponse<BetBuilderPickResponse[]>
	> {
		return httpClient.get(
			`${this.baseUrl}/presets`,
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}
}
